/*eslint-disable */
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FormField from "../common/FormField";
import { lazy, Suspense, useEffect, useMemo, useState } from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import ShadowWrapper from "../../utils/Shadow-Wrapper/ShadowWrapper";
import Tabs from "../../../../bmr/components/styled/Tab";
import { dispatch, store } from "../../../../store";
import {
  BarCodeOption,
  DateFormat,
  DecimalPlacesOption,
  DEPENDENCY_CONFIG,
  FIELD_TYPE,
  FileSize,
  LayoutOption,
  // MultiUploadOptions,
  TabPresetMap,
  TABS,
  TimeFormat,
  TimeFormatDisplay,
  VisualDisplay,
} from "../constant/constant";
import { useSelector } from "react-redux";
import LinkedFieldForm from "../shadowForms/LinkedFieldForm";
import {
  clearLinkedField,
  getAddDependencyField,
} from "../../slices/FbProperty";
import { fieldTypeDefaults } from "../../utils/schemas/initial";
import DependencyForm from "../shadowForms/DependencyForm";
import { Delete } from "@mui/icons-material";
import { sectionAutoSave, fetchSections } from "../../slices/FbSections";
import { useParams } from "react-router";
import DeleteModal from "../../../../bmr/components/common/BaseModal/DeleteModal/index.js";
import { ConfirmationInfoIcon } from "../../../../assets/common-svg/CommonSvg.js";

const ValidationForm = lazy(() => import("../shadowForms/ValidationForm"));
const RadioForm = lazy(() => import("../shadowForms/RadioForm"));
const CalculationForm = lazy(() => import("../shadowForms/CalculationForm"));
const ConditionForm = lazy(() => import("../shadowForms/ConditionForm"));
const ManualConditions = lazy(() => import("../shadowForms/ManualCondition"));
const DropdownForm = lazy(() => import("../shadowForms/DropdownForm"));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isActive = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      style={{
        display: isActive ? "block" : "none",
      }}
    >
      <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const FbPropertyTab = ({
  selectedField,
  selectedSection,
  sectionIndex,
  fieldIndex,
}) => {
  const { control, setValue: formSetValue, getValues } = useFormContext();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const [value, setValue] = useState(0);
  const [configureDecimal, setConfigureDecimal] = useState(false);

  const [pendingTypeChange, setPendingTypeChange] = useState(null);
  const [isChangingType, setIsChangingType] = useState(false);

  const formulaVariables = useSelector(
    (state) => state.bmrFbProperty.formulaVariables,
  );
  const sendingValue = getValues("sections");
  const sectionSchema = useWatch({ control, name: `sections` });
  const selectedFieldProp = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}]`,
  });
  const configureDecimalPlaces = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.decimal_places`,
  });
  //@info using the generic enabled property
  const enabled = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property`,
  });

  const hasData = enabled?.auto_increment?.fields?.some((field) =>
    field?.value?.trim(),
  );
  const fieldType =
    sectionSchema[sectionIndex]?.fields[fieldIndex]?.property?.field_type;
  const sectionType = sectionSchema[sectionIndex]?.property?.type;

  const masterAPIURLs = useSelector(
    (state) => state.bmrFormBuilderMaster.allLabel,
  );

  const inputTypes = useSelector((state) => state.bmrFbProperty.inputTypes);
  // const FieldsTypesOption = inputTypes.map((type) => ({ value: type.name, label: type.name })); //@info remove static number from dropdown might need later
  const FieldsTypesOption = inputTypes
    .filter(
      (type) => type.id !== 7 && (sectionType === "group" || type.id !== 19),
    ) // remove Static Number & current time
    .map((type) => ({
      value: type.name,
      label: type.name,
    }));

  const fieldVariableDict = useMemo(() => {
    const dict = {};

    sectionSchema?.forEach((section, sectionIndex) => {
      section?.fields?.forEach((field, fieldIndex) => {
        const label = `${sectionIndex + 1}.${fieldIndex + 1} ${field.label} (${
          field?.property?.field_type
        })`;
        dict[field.input_uuid] = label;
      });
    });

    return dict;
  }, [sectionSchema]);

  const dependsOnOptions = useMemo(() => {
    const options = [];

    sectionSchema?.forEach((section, sIdx) => {
      section?.fields?.forEach((field, fIdx) => {
        // skip current field
        if (sIdx === sectionIndex && fIdx === fieldIndex) return;

        const label = `${sIdx + 1}.${fIdx + 1} ${field.label} (${
          field?.property?.field_type
        })`;

        options.push({
          label,
          value: field.input_uuid,
        });
      });
    });

    return options;
  }, [sectionSchema, sectionIndex, fieldIndex]);

  const isMasterEnabled = enabled?.input_dropdown?.is_master;

  const blockedTabs = isMasterEnabled
    ? [TABS.CONDITION, TABS.MANUAL_CONDITION]
    : [];

  const activeTabs = TabPresetMap[fieldType] || [TABS.GENERAL];
  const visibleTabs = Object.values(TABS)
    .map((tab, index) => ({ label: tab, index }))
    .filter((tab) => activeTabs.includes(tab.label));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dependencyConfig = DEPENDENCY_CONFIG[fieldType];

  useEffect(() => {
    dispatch(clearLinkedField());
  }, [selectedField]);

  useEffect(() => {
    if (fieldType === FIELD_TYPE.CALCULATION && configureDecimalPlaces) {
      setConfigureDecimal(true);
    }
  }, [configureDecimalPlaces]);

  const handleDecimalSwitch = (e) => {
    if (!e.target.checked) {
      formSetValue(
        `sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.decimal_places`,
        null,
      );
    }
    setConfigureDecimal(e.target.checked);
  };
  const currentDateEnabled = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.current_date`,
  });

  const currentDateTimeEnabled = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.current_datetime`,
  });
  const currentTimeEnabled = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.current_time`,
  });

  const {
    fields: auto_increment_fields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields`,
  });
  const watchedFields = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields`,
  });

  const selectedSourceEndpoint = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.source_endpoint`,
  });

  // useEffect(() => {
  //   if (!selectedSourceEndpoint) return;

  //   const matchedAPI = masterAPIURLs?.data?.find(
  //     (item) => item.api_url === selectedSourceEndpoint
  //   );

  //   if (!matchedAPI) return;

  //   formSetValue(
  //     `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.default_query_params`,
  //     matchedAPI.default_query_params || {}
  //   );
  // }, [selectedSourceEndpoint]);

  const selectedMasterAPI = useMemo(() => {
    return masterAPIURLs?.data?.find(
      (item) => item.api_url === selectedSourceEndpoint,
    );
  }, [masterAPIURLs, selectedSourceEndpoint]);

  const dependParams = selectedMasterAPI?.depend_params || [];

  useEffect(() => {
    if (!selectedMasterAPI) return;

    formSetValue(
      `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.default_query_params`,
      selectedMasterAPI.default_query_params || {},
    );
  }, [selectedMasterAPI]);

  useEffect(() => {
    const fields = watchedFields || [];

    const sorted = [...fields].sort((a, b) => a.order - b.order);

    const concat = sorted
      .map((f) => f.value || "")
      .filter((v) => v)
      .join("");

    formSetValue(
      `sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.default_val`,
      concat,
    );
  }, [watchedFields]);

  useEffect(() => {
    if (!watchedFields) return;

    watchedFields.forEach((f, idx) => {
      const isValid = /^\d+$/.test(f.value || "");

      if (!isValid && f.is_checked) {
        formSetValue(
          `sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields[${idx}].is_checked`,
          false,
        );
      }
    });
  }, [watchedFields]);

  const handleRemove = (idx) => {
    const current = getValues(
      `sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields`,
    );

    const updated = current.filter((_, i) => i !== idx);

    const normalized = updated.map((f, i) => ({
      ...f,
      order: i + 1,
    }));

    formSetValue(
      `sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields`,
      normalized,
    );
  };

  const handleModalClose = () => {
    if (pendingTypeChange?.oldType) {
      formSetValue(
        `sections[${sectionIndex}].fields[${fieldIndex}].property.field_type`,
        pendingTypeChange.oldType,
      );
    }
    setPendingTypeChange(null);
  };

  const currentProperty = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property`,
  });

  const handleTypeChange = (e) => {
    const newType = e.target.value;
    const oldType = fieldType;

    if (isDirtyProperty(currentProperty, oldType)) {
      // Field has user-configured data — ask for confirmation first
      setPendingTypeChange({ newType, oldType });
    } else {
      // Clean slate — apply immediately
      applyTypeChange(newType);
    }
  };

  // 3. The actual type-apply logic (extracted so modal can call it too)
  const applyTypeChange = async (newType) => {
    try {
      setIsChangingType(true);
      const defaults = fieldTypeDefaults[newType] || {};
      const basePath = `sections[${sectionIndex}].fields[${fieldIndex}].property`;

      const currentLayout = getValues(`${basePath}.field_layout`);

      const allPropertyKeys = [
        "general",
        "note",
        "input_text",
        "input_radio",
        "input_dropdown",
        "input_number",
        "input_email",
        "input_current_time",
        "input_date",
        "input_date_and_time",
        "hyperlink",
        "file_upload",
        "image_upload",
        "toggle",
        "calculation",
        "auto_increment",
        "conditions",
        "validations",
      ];

      // Explicitly wipe out all old properties to ensure react-hook-form resets the UI
      allPropertyKeys.forEach((key) => {
        formSetValue(`${basePath}.${key}`, null);
      });

      // Apply the fresh defaults for the newly selected type
      Object.keys(defaults).forEach((key) => {
        formSetValue(`${basePath}.${key}`, defaults[key]);
      });

      formSetValue(`${basePath}.field_layout`, currentLayout || 12);
      formSetValue(`${basePath}.field_type`, newType);

      const currentFormData = getValues("sections");
      await dispatch(
        sectionAutoSave({
          id,
          data: { sections: currentFormData },
        }),
      ).unwrap();

      await dispatch(fetchSections(id)).unwrap();
    } catch (err) {
      console.error("Error changing field type", err);
    } finally {
      setIsChangingType(false);
    }
  };

  // 4. isDirty helpers — check if property has anything beyond bare defaults
  const normalize = (val) => {
    if (val === 0 || val === "0" || val === 0.0) return false;
    if (val === 1 || val === "1") return true;
    if (val === "" || val == null) return false;
    if (typeof val === "string") {
      const lower = val.trim().toLowerCase();
      if (lower === "none" || lower === "default" || lower === "false")
        return false;
      if (lower === "true") return true;
    }
    return val;
  };

  const isDirtyValue = (current, defaultValue) => {
    const normCurrent = normalize(current);
    const normDefault = normalize(defaultValue);

    if (normCurrent === normDefault) return false;

    if (Array.isArray(normDefault)) {
      if (!Array.isArray(normCurrent)) {
        if (normCurrent === false && normDefault.length === 0) return false;
        return true;
      }
      if (normCurrent.length !== normDefault.length) {
        if (normCurrent.length === 0 && normDefault.length === 0) return false;
        return true;
      }
      for (let i = 0; i < normDefault.length; i++) {
        if (isDirtyValue(normCurrent[i], normDefault[i])) return true;
      }
      return false;
    }

    if (typeof normDefault === "object" && normDefault !== null) {
      if (typeof normCurrent !== "object" || normCurrent === null) {
        if (normCurrent === false) {
          for (const key of Object.keys(normDefault)) {
            if (isDirtyValue(null, normDefault[key])) return true;
          }
          return false;
        }
        return true;
      }
      for (const key of Object.keys(normDefault)) {
        if (isDirtyValue(normCurrent[key], normDefault[key])) return true;
      }
      return false;
    }

    if (typeof normCurrent === "object" && normCurrent !== null) {
      if (normDefault === false) {
        for (const key of Object.keys(normCurrent)) {
          if (isDirtyValue(normCurrent[key], null)) return true;
        }
        return false;
      }
      return true;
    }

    return normCurrent !== normDefault;
  };

  const defaultBlocks = {};
  for (const type of Object.keys(fieldTypeDefaults)) {
    const blocks = fieldTypeDefaults[type];
    for (const blockKey of Object.keys(blocks)) {
      defaultBlocks[blockKey] = blocks[blockKey];
    }
  }

  const isDirtyProperty = (property, currentType) => {
    console.log(property, "PRORPERTY", currentType, "Current type");
    if (!property || !currentType) return false;

    // 1. Check direct configuration keys on property
    if (normalize(property.default_value) !== false) return true;
    if (normalize(property.restricted_num) !== false) return true;
    if (normalize(property.restricted_spl_char) !== false) return true;

    // 2. Check arrays (conditions, validations, option_conditions)
    if (property.conditions && property.conditions.length > 0) return true;
    if (property.validations && property.validations.length > 0) return true;
    if (property.option_conditions && property.option_conditions.length > 0)
      return true;

    // 3. Loop through all keys in property
    for (const key of Object.keys(property)) {
      if (key === "field_type" || key === "field_layout") continue;

      if (key === "calculation" || key === "auto_increment") {
        if (property[key] && typeof property[key] === "object") {
          for (const subKey of Object.keys(property[key])) {
            if (isDirtyValue(property[key][subKey], null)) return true;
          }
        }
        continue;
      }

      if (defaultBlocks[key]) {
        // If the current value is null or undefined, it's not configured/dirty
        if (property[key] == null) continue;

        if (isDirtyValue(property[key], defaultBlocks[key])) {
          return true;
        }
      }
    }

    return false;
  };

  const currentFormData =
    typeof getValues === "function" ? getValues("sections") : null;
  const handleSave = async () => {
    try {
      setIsSaving(true);

      await dispatch(
        sectionAutoSave({
          id,
          data: { sections: currentFormData },
        }),
      ).unwrap();
    } finally {
      setIsSaving(false);
    }
  };

  const masterOptions = useMemo(() => {
    return (
      masterAPIURLs?.data?.map((item) => ({
        value: item.api_url,
        label: item.label,
      })) || []
    );
  }, [masterAPIURLs]);

  const dependsOnValue = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.depends_on`,
  });

  const dependentOptions = useMemo(() => {
    const allOptions =
      masterAPIURLs?.data?.map((item) => ({
        value: item.api_url,
        label: item.label,
        category: item.category,
      })) || [];

    if (!dependsOnValue) return allOptions;

    // Find the parent field across all sections
    let parentField = null;
    sectionSchema?.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.input_uuid === dependsOnValue) {
          parentField = field;
        }
      });
    });

    const parentEndpoint =
      parentField?.property?.input_dropdown?.source_endpoint;
    if (!parentEndpoint) return allOptions;

    const parentEntry = masterAPIURLs?.data?.find(
      (item) => item.api_url === parentEndpoint,
    );

    const parentCategory = parentEntry?.category;

    if (parentCategory) {
      const filtered = allOptions.filter(
        (opt) =>
          opt.category?.toLowerCase() === parentCategory.toLowerCase() &&
          opt.value !== parentEndpoint,
      );
      return filtered.length > 0 ? filtered : allOptions;
    }

    return allOptions;
  }, [dependsOnValue, sectionSchema, masterAPIURLs]);

  return (
    <Box
      className="bg-white rounded-2xl h-full overflow-y-auto border-[0.11rem] border-white"
      position="relative"
    >
      {isChangingType && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={9999}
          bgcolor="rgba(255, 255, 255, 0.7)"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress />
        </Box>
      )}
      <div className="h-[49px] bg-[#E8EFFC] gap-[25px] p-[15px] rounded-tl-[10px] rounded-tr-[10px]">
        <Typography variant="h6" fontWeight="bold">
          Properties Tab
        </Typography>
      </div>
      <Box className="p-3" key={`property-${selectedSection}-${selectedField}`}>
        <Box>
          <Typography className="text-black p-2 break-all capitalize">
            {sectionIndex + 1}.{fieldIndex + 1} {selectedFieldProp?.label}{" "}
            {/* @info removed +1 because already in index  */}
          </Typography>
          <Divider sx={{ mb: "0.9rem" }} />
          <Box>
            <FormField
              sx={{
                borderRadius: "0.6rem !important",
                backgroundColor: "#F0F1F5 !important",
                color: "#777777",
              }}
              name={`sections.${sectionIndex}.fields.${fieldIndex}.property.field_layout`}
              inputLabelTop="Input Field Layout"
              placeholder="Select the layout"
              type="select"
              size="small"
              options={LayoutOption}
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              sx={{
                borderRadius: "0.6em !important",
                backgroundColor: "#F0F1F5 !important",
                color: "#777777",
              }}
              name={`sections.${sectionIndex}.fields.${fieldIndex}.property.field_type`}
              inputLabelTop="Input field type"
              placeholder="Select the type"
              type="select"
              size="small"
              options={FieldsTypesOption}
              onChange={handleTypeChange}
            />
            <Divider sx={{ mb: "0.9rem" }} />
          </Box>
          <Box className="">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {visibleTabs.map((tab) => {
                const isBlocked = blockedTabs.includes(tab.label);

                const tabComponent = (
                  <Tab
                    key={`tab-${tab.label}`}
                    label={tab?.label}
                    disabled={isBlocked}
                    {...a11yProps(tab.index)}
                    sx={{
                      opacity: isBlocked ? 0.5 : 1,
                    }}
                  />
                );

                if (isBlocked) {
                  return (
                    <Tooltip
                      key={`tooltip-${tab.label}`}
                      title="This tab is disabled because Master Data is enabled"
                      arrow
                    >
                      <span
                        style={{
                          cursor: "not-allowed",
                        }}
                      >
                        {tabComponent}
                      </span>
                    </Tooltip>
                  );
                }

                return tabComponent;
              })}
            </Tabs>
          </Box>
        </Box>

        <Box>
          {/* General */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.GENERAL)}
          >
            <Box key={`property-${selectedSection}-${selectedField}`}>
              {/* @info removing raise query as data is not fetching from BE */}
              {/* <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.raise_query`}
                label="Raise Query"
                type="switch"
                size="small"
                description={
                  "Enabling this will help to raise query for this input field."
                }
              />
              <Divider sx={{ mb: "0.9rem" }} /> */}
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.required`}
                label="Required"
                type="switch"
                size="small"
                description={
                  "Defines either a recorded value is necessary to complete the task records"
                }
              />
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.disable`}
                label="Disable"
                type="switch"
                size="small"
                description={
                  "Disable this field to prevent users from entering or modifying its value."
                }
              />
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.remove_heading`}
                label="Remove heading"
                type="switch"
                size="small"
                description={
                  "Enable this to hide the heading and display only the field."
                }
              />
              <Divider sx={{ mb: "0.9rem" }} />
              {/* @info removed from UI as not getting in preview */}
              {/* <Typography variant="subtitle1" fontWeight="500">
                Display Visual Separator
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                mb={1}
                fontWeight="400"
              >
                Determines display and location of a separator between this
                field and neighbor.
              </Typography>
              <FormField
                sx={{
                  borderRadius: "0.6rem !important",
                  backgroundColor: "#F0F1F5 !important",
                  color: "#777777",
                }}
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.display_visuals_line`}
                type="select"
                size="small"
                options={VisualDisplay}
                placeholder="Select"
              /> */}
            </Box>
          </TabPanel>

          {/* Note */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.NOTE)}
          >
            <Box
              key={`property-${selectedSection}-${selectedField}`}
              sx={{
                border: "1px solid #F0F1F5",
                borderRadius: "0.375rem",
                padding: "10px",
              }}
            >
              <Typography variant="subtitle1" fontWeight="400">
                Notes
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                mb={1}
                fontWeight="400"
              >
                Any note(s) relevant to this field will be shown in the form.
              </Typography>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.note.message_note`}
                type="textarea"
                placeholder="Add Note"
              />
            </Box>
          </TabPanel>

          {/* Validation */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.VALIDATIONS)}
            className="p-0 m-0"
          >
            <ShadowWrapper
              component={ValidationForm}
              fieldId={selectedField}
              store={store}
            />
          </TabPanel>

          {/* Label */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.LABEL)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.default_value`}
              inputLabelTop="Default Value (if required)"
              type="text"
              placeholder="Enter Default Value"
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.restricted_num`}
              label="Restrict Numeric Value"
              type="switch"
              description={"Blocks all the numeric value"}
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.restricted_spl_char`}
              label="Restrict Special Character"
              type="switch"
              description={
                "Will not allow any special character in input feild"
              }
            />
          </TabPanel>

          {/*  Create Toggle here */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.TOGGLE)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.toggle_msg_1`}
              inputLabelTop="Toggle message 1"
              placeholder="Message 1"
              size="small"
              description="Defines the toggled output message; usually 'Done' or 'confirmed', but can be any text"
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.toggle_msg_2`}
              inputLabelTop="Toggle message 2"
              size="small"
              placeholder="Message 2"
              description="Defines the toggled output message; usually 'Done' or 'confirmed', but can be any text"
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {/* @info not getting from BE */}
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.display_visuals_line`}
              inputLabelTop="Display Visual Seperator"
              type="select"
              size="small"
              placeholder="Select"
              options={VisualDisplay}
              description={
                "Determines display and location of a separator between this field and neighbour."
              }
            />
            <Divider sx={{ mb: "0.9rem" }} /> */}
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.default_msg`}
              inputLabelTop="Default toggle message"
              type="select"
              size="small"
              placeholder="Select"
            />
            <Divider sx={{ mb: "0.9rem" }} /> */}
          </TabPanel>

          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_RADIO)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_radio.is_horizontal`}
              label="Alignment Horizontal"
              type="switch"
              size="small"
              description={"Aligns the radio options horizontally"}
            />

            {fieldType === FIELD_TYPE.INPUT_RADIO && (
              <ShadowWrapper
                component={RadioForm}
                fieldId={selectedField}
                store={store}
              />
            )}
          </TabPanel>

          {/* Input Dropdown */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_DROPDOWN,
            )}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.is_master`}
              label="Enable Master Data"
              type="switch"
              description={
                "Toggle to use predefined master data instead of manual input."
              }
              onChange={(checked) => {
                if (!checked) {
                  const basePath = `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown`;
                  formSetValue(`${basePath}.is_dependent`, false);
                  formSetValue(`${basePath}.source_endpoint`, null);
                  formSetValue(`${basePath}.dependent_endpoint`, null);
                  formSetValue(`${basePath}.dependent_query_params`, []);
                  formSetValue(`${basePath}.depends_on`, null);
                  formSetValue(`${basePath}.master_dependencies`, []);
                  formSetValue(`${basePath}.is_visible`, true);
                  formSetValue(`${basePath}.is_data_visible`, false);
                }
              }}
            />
            {enabled?.input_dropdown?.is_master && (
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.source_endpoint`}
                placeholder="Master API url"
                type="select"
                searchable={true}
                options={masterOptions}
                description={
                  "Toggle to use predefined master data instead of manual input."
                }
                onChange={() => {
                  const basePath = `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown`;
                  formSetValue(`${basePath}.is_dependent`, false);
                  formSetValue(`${basePath}.dependent_endpoint`, null);
                  formSetValue(`${basePath}.dependent_query_params`, []);
                  formSetValue(`${basePath}.depends_on`, null);
                  formSetValue(`${basePath}.master_dependencies`, []);
                  formSetValue(`${basePath}.is_visible`, true);
                  formSetValue(`${basePath}.is_data_visible`, false);
                }}
              />
            )}

            {enabled?.input_dropdown?.is_master &&
              enabled?.input_dropdown?.source_endpoint && (
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.is_dependent`}
                  label="Is dependent"
                  type="switch"
                  description="Enable dependency configuration."
                />
              )}

            {enabled?.input_dropdown?.is_master &&
              enabled?.input_dropdown?.source_endpoint &&
              enabled?.input_dropdown?.is_dependent && (
                <>
                  {/* RESET FIELDS */}

                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.is_visible`}
                    type="switch"
                    size="medium"
                    label1="Data Visibility"
                    label2="Field Visibility"
                    onChange={(checked) => {
                      formSetValue(
                        `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.is_data_visible`,
                        !checked,
                      );
                    }}
                  />

                  {dependParams?.length > 0 ? (
                    <>
                      <Typography
                        variant="subtitle2"
                        fontWeight="600"
                        mt={2}
                        mb={1}
                      >
                        Master Dependencies
                      </Typography>

                      <Box display="flex" flexWrap="wrap" gap={1}>
                        {dependParams.map((param) => {
                          const dependencyIndex =
                            enabled?.input_dropdown?.master_dependencies?.findIndex(
                              (d) => d.query_param === param,
                            );

                          const isChecked = dependencyIndex >= 0;

                          return (
                            <Box key={param}>
                              <Box display="flex" alignItems="center">
                                <Checkbox
                                  checked={isChecked}
                                  sx={{
                                    color: "success.main",
                                    "&.Mui-checked": {
                                      color: "success.main",
                                    },
                                  }}
                                  onChange={(e) => {
                                    const current =
                                      enabled?.input_dropdown
                                        ?.master_dependencies || [];

                                    if (e.target.checked) {
                                      formSetValue(
                                        `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.master_dependencies`,
                                        [
                                          ...current,
                                          {
                                            query_param: param,
                                            field_uuid: "",
                                          },
                                        ],
                                      );
                                    } else {
                                      const filtered = current.filter(
                                        (d) => d.query_param !== param,
                                      );

                                      formSetValue(
                                        `sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.master_dependencies`,
                                        filtered,
                                      );
                                    }
                                  }}
                                />

                                <Chip
                                  label={param}
                                  color={isChecked ? "success" : "default"}
                                />
                              </Box>

                              {/* FIELD UUID */}
                              {isChecked && (
                                <Box mt={1} ml={1}>
                                  {dependsOnOptions.length === 0 ? (
                                    <Typography variant="caption">
                                      No dependency fields available
                                    </Typography>
                                  ) : (
                                    <FormField
                                      name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.master_dependencies[${dependencyIndex}].field_uuid`}
                                      inputLabelTop="Select Field"
                                      placeholder="Select Field"
                                      type="select"
                                      options={dependsOnOptions}
                                    />
                                  )}
                                </Box>
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    </>
                  ) : (
                    <>
                      {/* ========================= */}
                      {/* NO DEPEND PARAMS */}
                      {/* ========================= */}

                      {dependsOnOptions.length === 0 ? (
                        <Typography variant="caption">
                          No dependency fields available
                        </Typography>
                      ) : (
                        <FormField
                          name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_dropdown.depends_on`}
                          placeholder="Depends On"
                          type="select"
                          options={dependsOnOptions}
                        />
                      )}
                    </>
                  )}
                </>
              )}
            {!enabled?.input_dropdown?.is_master &&
              !enabled?.input_dropdown?.is_dependent &&
              fieldType === FIELD_TYPE.INPUT_DROPDOWN && (
                <ShadowWrapper
                  component={RadioForm}
                  fieldId={selectedField}
                  store={store}
                  control={control}
                />
              )}
            {enabled?.input_dropdown?.is_master && (
              <Box className="flex justify-end w-auto mt-2">
                <Button
                  onClick={handleSave}
                  disabled={isSaving}
                  startIcon={
                    isSaving ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                >
                  {isSaving ? "Saving..." : "Save"}
                </Button>
              </Box>
            )}
          </TabPanel>

          {/* Input Checkbox */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_CHECKBOX,
            )}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_checkbox.alignment_horizontal`}
              label="Alignment Horizontal"
              type="switch"
              description={"Aligns the checkbox horizontally"}
            />

            {fieldType === FIELD_TYPE.INPUT_CHECKBOX && (
              <ShadowWrapper
                component={RadioForm}
                fieldId={selectedField}
                store={store}
                control={control}
              />
            )}
          </TabPanel>

          {/* Input Text */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_TEXT)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.default_val`}
              inputLabelTop="Default Value (if required)"
              placeholder="Enter Default Value"
              size="small"
              sx={{
                marginRight: "0px !important",
              }}
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.measurement_unit_text`}
              inputLabelTop="Measurement Unit (if required)"
              placeholder="Enter Unit"
              size="small"
              sx={{
                marginRight: "0px !important",
              }}
            />

            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.restrict_number`}
                type="switch"
                size="small"
                sx={{
                  marginRight: "0px !important",
                }}
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Restrict Numeric Value
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Blocks all the numeric value
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.restrict_spl_char`}
                type="switch"
                size="small"
                sx={{
                  marginRight: "0px !important",
                }}
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Restrict Special Character
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Will not allow any special character in the input field.
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.restrict_email`}
                type="switch"
                size="small"
                sx={{
                  marginRight: "0px !important",
                }}
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Restrict Email Validation
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Will check for correct email format that is “abc@email.com”
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.max_limit`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Triggers the validation message above the defined value
                </Typography>
              </Box>
            </Box>
            {enabled?.input_text?.max_limit && (
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The upper limit for the validation range, triggers below
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.max_limit_range`}
                  size="small"
                  placeholder="Enter maximum limit value"
                />
              </>
            )}
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.min_limit`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Triggers the validation message below the defined value
                </Typography>
              </Box>
            </Box>
            {enabled?.input_text?.min_limit && (
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The lower limit for the validation range, triggers above.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.min_limit_range`}
                  size="small"
                  placeholder="Enter minimum limit value"
                />
              </>
            )}
          </TabPanel>

          {/* auto_increment */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_AUTOINCREMENT,
            )}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.default_val`}
              inputLabelTop="Default Value (computed)"
              placeholder="Computed from fields"
              size="small"
              disabled
              sx={{
                marginRight: "0px !important",
              }}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <Typography variant="subtitle1" fontWeight="500">
              Fields
            </Typography>
            {auto_increment_fields.map((f, idx) => (
              <Box key={f.id} display="flex" alignItems="center" gap={1} mb={1}>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields[${idx}].value`}
                  placeholder="Enter value"
                  size="small"
                  sx={{ flex: 1 }}
                />

                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={0.25}
                  sx={{
                    "& .MuiSwitch-root": {
                      margin: 0,
                      padding: 0,
                      width: 42,
                    },
                  }}
                >
                  <Tooltip
                    title={
                      /^\d+$/.test(watchedFields?.[idx]?.value || "")
                        ? "Include in auto increment"
                        : "Enter a numeric value first"
                    }
                    arrow
                  >
                    <span>
                      <FormField
                        name={`sections[${sectionIndex}].fields[${fieldIndex}].property.auto_increment.fields[${idx}].is_checked`}
                        type="switch"
                        size="small"
                        disabled={
                          !/^\d+$/.test(watchedFields?.[idx]?.value || "")
                        }
                      />
                    </span>
                  </Tooltip>

                  <Tooltip title="Remove field" arrow>
                    <IconButton
                      size="medium"
                      onClick={() => handleRemove(idx)}
                      sx={{
                        p: 0.75,
                        mb: 1,
                        color: "red",
                        "&:hover": {
                          backgroundColor: "grey.100",
                          color: "error.main",
                        },
                      }}
                    >
                      <Delete sx={{ fontSize: 28 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            ))}
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                const nextOrder =
                  auto_increment_fields.length > 0
                    ? Math.max(
                        ...auto_increment_fields.map((f) => f.order || 0),
                      ) + 1
                    : 1;
                append({ order: nextOrder, value: "", is_checked: false });
              }}
            >
              Add Field
            </Button>

            {hasData && (
              <Box className="flex justify-end w-auto mt-2">
                <Button
                  onClick={handleSave}
                  disabled={isSaving}
                  startIcon={
                    isSaving ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                >
                  {isSaving ? "Saving..." : "Save"}
                </Button>
              </Box>
            )}
          </TabPanel>

          {/* Input Number */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_NUMBER)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.default_val`}
              inputLabelTop="Default Value (if required)"
              placeholder="Enter Default Value"
              size="small"
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.measurement_unit`}
              inputLabelTop="Measurement Unit (if required)"
              placeholder="Enter Measurement Unit"
              size="small"
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {/* @info commented these field due to its not working on the preview   */}
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.positive_number`}
              label="Only Positive Number"
              type="switch"
              size="small"
              description={
                "Blocks negative values, message configurable in Validation "
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.whole_number`}
              label="Only Whole Numbers"
              type="switch"
              size="small"
              description={
                "Will only allow any positive number that does not include a decimal part "
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.restrict_text`}
              label="Restrict Text Character"
              type="switch"
              size="small"
              description={
                "will only allow numeric values, and no characters are allowed. "
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.decimal_notation`}
              label="Decimal Notation"
              type="switch"
              size="small"
              description={
                "Field value will be displayed using field-specific decimal configuration"
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {enabled?.input_number?.decimal_notation && (
              <>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.decimal_notation_places`}
                  inputLabelTop="Decimal Places"
                  placeholder="Select"
                  type="select"
                  options={DecimalPlacesOption}
                />
                <Divider sx={{ mb: "0.9rem" }} />
              </>
            )}
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.scientific_notation`}
              label="Scientific Notation"
              type="switch"
              size="small"
              description={
                "If enabled, the field value will be displayed using scientific notation"
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {enabled?.input_number?.scientific_notation && (
              <>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.scientific_exponent_notation`}
                  inputLabelTop="Exponent"
                  placeholder="Select"
                  type="select"
                  options={DecimalPlacesOption}
                />
                <Divider sx={{ mb: "0.9rem" }} />
              </>
            )}
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.max_limit`}
              label="Maximum Limit"
              type="switch"
              size="small"
              description="Triggers the validation message above the defined value"
            />
            {enabled?.input_number?.max_limit && (
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.max_limit_range`}
                inputLabelTop="Maximum Limit Value"
                placeholder="Enter Maximum Limit"
                description="Triggers the validation message above the defined value"
              />
            )}
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.min_limit`}
              label="Minimum Limit"
              type="switch"
              size="small"
              description="Triggers the validation message below the defined value"
            />
            {enabled?.input_number?.min_limit && (
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.min_limit_range`}
                inputLabelTop="Minimum Limit Value"
                placeholder="Enter Minimum Limit"
                description="Triggers the validation message below the defined value"
              />
            )} */}
          </TabPanel>

          {/* Input email */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_EMAIL)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_email.input_email_format`}
              label="Valid email format "
              type="switch"
              size="small"
              // description="Blocks all other file type"
            />
          </TabPanel>

          {/* Input Current Time */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_CURRENT_TIME,
            )}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.time_format`}
              inputLabelTop="Time Format"
              type="select"
              options={TimeFormat}
              placeholder={"Select"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.time_display_format`}
              inputLabelTop="Time Display Format"
              type="select"
              options={TimeFormatDisplay}
              placeholder={"Select"}
            />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.current_time`}
                type="switch"
                size="small"
                onChange={(e) => {
                  if (e.target.checked) {
                    formSetValue(
                      `sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.default_time`,
                      null, // or "" based on your form config
                    );
                  }
                }}
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Current Date
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  When enabled, the field is automatically filled with today’s
                  time.
                </Typography>
              </Box>
            </Box>
          </TabPanel>

          {/* Input Date */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_DATE)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.date_display_format`}
              inputLabelTop="Date Display Format"
              type="select"
              options={DateFormat}
              placeholder={"Select"}
            />

            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.current_date`}
                type="switch"
                size="small"
                onChange={(e) => {
                  if (e.target.checked) {
                    formSetValue(
                      `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.default_date`,
                      null, // or "" based on your form config
                    );
                  }
                }}
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Current Date
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  When enabled, the field is automatically filled with today’s
                  date.
                </Typography>
              </Box>
            </Box>
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.default_date`}
              inputLabelTop="Default Date"
              type="date"
              options={DateFormat}
              placeholder={"Select"}
              disabled={currentDateEnabled}
              dateFormat={
                enabled?.input_date?.date_display_format || "DD/MM/YY"
              }
            />

            {/* Addign the fields */}
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.date_range`}
              label="Range allowed"
              type="switch"
              size="small"
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.past_only`}
              label="Past Dates Allowed "
              type="switch"
              size="small"
              onChange={(e) => {
                if (e.target.checked) {
                  formSetValue(
                    `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.future_only`,
                    false,
                  );
                }
              }}
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.future_only`}
              label="Future Dates Allowed "
              type="switch"
              size="small"
              onChange={(e) => {
                if (e.target.checked) {
                  //@info All sets are managed from the field component, this is to make upper one disable
                  formSetValue(
                    `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.past_only`,
                    false,
                  );
                }
              }}
            />

            {/* min and max range */}

            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.max_date_enabled`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Triggers the validation message above the defined value
                </Typography>
              </Box>
            </Box>
            {enabled?.input_date?.max_date_enabled && (
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The upper limit for the validation range, triggers below
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.max_date`}
                  type="date"
                  size="small"
                  placeholder="Enter maximum limit value"
                  dateFormat={
                    enabled?.input_date?.date_display_format || "DD/MM/YY"
                  }
                />
              </>
            )}
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.min_date_enabled`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Triggers the validation message below the defined value
                </Typography>
              </Box>
            </Box>
            {enabled?.input_date?.min_date_enabled && (
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The lower limit for the validation range, triggers above.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.min_date`}
                  type="date"
                  size="small"
                  placeholder="Enter minimum limit value"
                  dateFormat={
                    enabled?.input_date?.date_display_format || "DD/MM/YY"
                  }
                />
              </>
            )}
          </TabPanel>

          {/* Input Date and Time */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_DATE_AND_TIME,
            )}
          >
            {/* Here need to be added!!!. */}
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.time_format`}
              inputLabelTop="Time Format"
              type="select"
              options={TimeFormat}
              placeholder={"Select"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.time_display_format`}
              inputLabelTop="Time Display Format"
              type="select"
              options={TimeFormatDisplay}
              placeholder={"Select"}
            /> */}
            {/* <Divider sx={{ mb: "0.9rem" }} /> */}
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.date_display_format`}
              inputLabelTop="Date Display Format"
              type="select"
              options={DateFormat}
              placeholder={"Select"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {/* Addign the fields */}

            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.current_datetime`}
                type="switch"
                size="small"
                onChange={(e) => {
                  if (e.target.checked) {
                    formSetValue(
                      `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.default_datetime`,
                      null, // or "" based on your form config
                    );
                  }
                }}
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Current Date
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  When enabled, the field is automatically filled with today’s
                  date.
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.default_datetime`}
              inputLabelTop="Default Date"
              type="datetime"
              options={DateFormat}
              placeholder={"Select"}
              disabled={currentDateTimeEnabled}
              combineDate={
                enabled?.input_date_and_time?.date_display_format || "DD/MM/YY"
              }
              combineTime={enabled?.input_date_and_time?.time_format || "HH:mm"}
            />

            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.past_only_datetime`}
              label="Past Dates Allowed "
              type="switch"
              size="small"
              onChange={(e) => {
                if (e.target.checked) {
                  formSetValue(
                    `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.future_only_datetime`,
                    false,
                  );
                }
              }}
            />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.future_only_datetime`}
              label="Future Dates Allowed "
              type="switch"
              size="small"
              onChange={(e) => {
                if (e.target.checked) {
                  //@info All sets are managed from the field component, this is to make upper one disable
                  formSetValue(
                    `sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.past_only_datetime`,
                    false,
                  );
                }
              }}
            />

            {/* min and max range */}

            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.max_datetime_enabled`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Triggers the validation message above the defined value
                </Typography>
              </Box>
            </Box>
            {enabled?.input_date_and_time?.max_datetime_enabled && (
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The upper limit for the validation range, triggers below
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.max_datetime`}
                  type="datetime"
                  size="small"
                  placeholder="Enter maximum limit value"
                  combineDate={
                    enabled?.input_date_and_time?.date_display_format ||
                    "DD/MM/YY"
                  }
                  combineTime={
                    enabled?.input_date_and_time?.time_format || "HH:mm"
                  }
                />
              </>
            )}
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start">
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.min_datetime_enabled`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: "0.9rem" }}>
                <Typography variant="body1" fontWeight="500">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="subtitle2"
                  fontWeight="400"
                  sx={{ color: "#828282" }}
                >
                  Triggers the validation message below the defined value
                </Typography>
              </Box>
            </Box>
            {enabled?.input_date_and_time?.min_datetime_enabled && (
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The lower limit for the validation range, triggers above.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.min_datetime`}
                  type="datetime"
                  size="small"
                  placeholder="Enter minimum limit value"
                  combineDate={
                    enabled?.input_date_and_time?.date_display_format ||
                    "DD/MM/YY"
                  }
                  combineTime={
                    enabled?.input_date_and_time?.time_format || "HH:mm"
                  }
                />
              </>
            )}
          </TabPanel>

          {/* Linked Field */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.LINKED_FIELD)}
          >
            {fieldType === FIELD_TYPE.LINKED_FIELD && (
              <ShadowWrapper
                component={LinkedFieldForm}
                fieldId={selectedField}
                store={store}
              />
            )}
          </TabPanel>

          {/* Hyperlink */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.HYPERLINK)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.hyperlink.name`}
              inputLabelTop="Name"
              placeholder={"Enter Name"}
              size="small"
              description={"The displayed text of the URI in the eBR / form"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              size="small"
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.hyperlink.url`}
              inputLabelTop="URL"
              placeholder={"Enter URL"}
              description={
                "The URI of the hyperlinked location (e.g. https://www.google.com)"
              }
            />
          </TabPanel>

          {/* BarCode */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.BARCODE)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.barcode.format`}
              inputLabelTop="Barcode Format"
              type="select"
              options={BarCodeOption}
              size="small"
              placeholder={"Select"}
              description={"Defines the type of barcode to output."}
            />
          </TabPanel>

          {/* File upload */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.FILE_UPLOAD)}
          >
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_pdf_file_only`}
              label="Allow only .pdf file"
              type="switch"
              size="small"
              description="Blocks all other file typee."
            />
            {/* @info this is not working on the preview for user file upload  */}
            {/* <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_other_file_format`}
              label="Allow only JPEG, PNG, and WebP format"
              type="switch"
              size="small"
              description="Blocks all other file type."
            />

            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_multi_upload`}
              label="Allow Multi Upload"
              type="switch"
              size="small"
              description="Enables you to upload multiple files"
            />
            {enabled?.file_upload?.allow_multi_upload && //@info check this once
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Limit Multi Upload
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Set a limit on how much the user can upload.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_multi_upload_limit`}
                  size="small"
                  type="select"
                  options={MultiUploadOptions}
                  placeholder="Select"
                />
              </>
            } 
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.size_per_file`}
              inputLabelTop="Size per file"
              placeholder="Enter size"
              type="number"
              description={
                "Will restrict all the files whose size is larger than the mentioned file size."
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.file_size_unit`}
              inputLabelTop="File Size Measurements Unit"
              placeholder="Select"
              type="select"
              options={FileSize}
            />
            <Divider sx={{ mb: "0.5rem" }} /> */}
          </TabPanel>

          {/* Image upload */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.IMAGE_UPLOAD)}
          >
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.allow_jpg_only`}
              label="Allow only JPEG image"
              type="switch"
              size="small"
              description="Restricts all other image types except JPEG"
            />
            {/* // @info no need of dimension 
             {enabled?.file_upload?.allow_jpg_only &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Image Dimension
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Mention width and height of the image.
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Width"
                  />
                  <Typography sx={{ fontWeight: '700' }}>x</Typography>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Height"
                  />
                </Box>
              </>
            } 

            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.allow_other_format`}
              label="Allow other formats like PNG, WebP"
              type="switch"
              size="small"
              description="Do not restrict other image formats"
            />

             {enabled?.file_upload?.allow_other_format &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Image Dimension
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Mention width and height of the image.
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Width"
                  />
                  <Typography sx={{ fontWeight: '700' }}>x</Typography>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Height"
                  />
                </Box>
                      </>
            } 
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.allow_multi_upload`}
              label="Allow Multi Upload"
              type="switch"
              size="small"
              description="Enables you to upload multiple images"
            />
             {enabled?.image_upload?.allow_multi_upload &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Limit Multi Upload
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Set a limit on how much the user can upload.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.multi_upload_limit`}
                  size="small"
                  type="select"
                  options={MultiUploadOptions}
                  placeholder="Select"
                />
              </>
            } 
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.size_per_file`}
              inputLabelTop="Size per file"
              placeholder="Enter size"
              type="number"
              description={
                "Will restrict all the images whose size is larger than the mentioned file size."
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.file_size_unit`}
              inputLabelTop="Image Size Measurements Unit"
              placeholder="Select"
              type="select"
              options={FileSize}
            />
            <Divider sx={{ mb: "0.9rem" }} /> */}
          </TabPanel>

          {/* Calculation  */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.CALCULATION)}
          >
            <Box sx={{ mt: 2 }}>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.formula`}
                inputLabelTop="Formula"
                placeholder="$Value1 + $Value2"
              />
              <Divider sx={{ mb: 1 }}></Divider>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.unit_of_measurement`}
                inputLabelTop="Unit of measurement (if required)"
                placeholder={"Enter measurement unit"}
              />
              <Divider sx={{ mb: 1 }}></Divider>

              <FormField
                sx={{ mb: 0 }}
                type="switch"
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.display_formula`}
                label="Display Formula"
                description="Determines display of the parsed formula in the eBR / form"
              />
              <Divider sx={{ mb: 1 }}></Divider>

              {/* @info removed as not getting in preivew */}
              {/* <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.configure_decimal`}
                type="switch"
                label="Configure Number of Decimal Places"
                // checked={configureDecimal}
                // onChange={(e) => handleDecimalSwitch(e)}
                description="If enabled the field value will be displayed using field-specific decimal configuration"
              />
              <Divider sx={{ mb: 1 }}></Divider>
                 {enabled?.calculation?.configure_decimal &&(
                <>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.decimal_places`}
                    inputLabelTop="Decimal Places"
                    type="select"
                    options={DecimalPlacesOption}
                    placeholder={"Select"}
                  />
                  <Divider sx={{ mb: 1 }}></Divider>
                </>
              )} */}
              {formulaVariables?.length > 0 && (
                <>
                  <Typography sx={{ mb: 1 }}>Linked Fields</Typography>
                  {formulaVariables.map((item) => {
                    if (!item.name) {
                      return "NA";
                    }
                    return (
                      <Typography
                        sx={{
                          bgcolor: "lightgray",
                          p: "2px",
                          pl: "5px",
                          mb: 1,
                          borderRadius: "5px",
                        }}
                        key={item.linked_field_uuid}
                      >
                        {item.name}: {fieldVariableDict[item.linked_field_uuid]}{" "}
                      </Typography>
                    );
                  })}
                </>
              )}

              <Box className="flex justify-end w-auto mt-2">
                <Button
                  onClick={handleSave}
                  disabled={isSaving}
                  startIcon={
                    isSaving ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                >
                  {isSaving ? "Saving..." : "Save"}
                </Button>
              </Box>
            </Box>
          </TabPanel>

          {/* Formula Variable  */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.FORMULA_VARIABLES,
            )}
          >
            {fieldType === FIELD_TYPE.CALCULATION && (
              <ShadowWrapper
                component={CalculationForm}
                fieldId={selectedField}
                store={store}
                getValues={sendingValue}
              />
            )}
          </TabPanel>

          {/* Conditional */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.CONDITION)}
          >
            {[
              FIELD_TYPE.INPUT_DROPDOWN,
              FIELD_TYPE.INPUT_RADIO,
              FIELD_TYPE.INPUT_CHECKBOX,
              FIELD_TYPE.TOGGLE,
            ].includes(fieldType) && (
              <ShadowWrapper
                component={ConditionForm}
                fieldId={selectedField}
                store={store}
                getValues={sendingValue}
              />
            )}
          </TabPanel>

          {/* Manual Condition */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.MANUAL_CONDITION,
            )}
          >
            <ShadowWrapper
              component={ManualConditions}
              fieldId={selectedField}
              store={store}
              getValues={sendingValue}
            />
          </TabPanel>

          {/* Conditional */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.DEPENDENCY)}
          >
            {[
              FIELD_TYPE.INPUT_CURRENT_TIME,
              FIELD_TYPE.INPUT_DATE,
              FIELD_TYPE.INPUT_DATE_AND_TIME,
            ].includes(fieldType) && (
              <ShadowWrapper
                component={DependencyForm}
                fieldId={selectedField}
                store={store}
                getValues={sendingValue}
                formSetValue={formSetValue}
                sectionIndex={sectionIndex}
                fieldIndex={fieldIndex}
                config={dependencyConfig}
              />
            )}
          </TabPanel>
        </Box>
      </Box>
      {/* Type Change Confirmation Modal */}
      <DeleteModal
        open={Boolean(pendingTypeChange)}
        setClose={handleModalClose}
        title={
          <>
            <span>This field already has configured properties.</span>
            <br />
            <span>
              Changing the input type will reset all current settings to the
              defaults for <strong>{pendingTypeChange?.newType}</strong>.
            </span>
            <br />
            <span>Do you want to proceed?</span>
          </>
        }
        buttonText="Yes"
        fontWeight={300}
        btnPrimary={"#90fb2cff"}
        handleSuccess={async () => {
          const newType = pendingTypeChange.newType;
          setPendingTypeChange(null);
          await applyTypeChange(newType);
        }}
        handleRejection={handleModalClose}
        rejectButtonText="No"
        otherIcon={
          <ConfirmationInfoIcon Height={110} Width={110} Filled="#FB9D2C" />
        }
      />
    </Box>
  );
};
export default FbPropertyTab;
